"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubsTwisterBuyBoxDesktopWrapper = exports.SubsTwisterBuyBoxAlertDesktopWrapper = exports.SubsTwisterBuyBoxAlertMobileWrapper = exports.SubsTwisterBuyBoxMobileWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const SubsTwisterBuyBoxWrapperCommon = `
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
`;
exports.SubsTwisterBuyBoxMobileWrapper = styled_components_1.default.div `
  ${SubsTwisterBuyBoxWrapperCommon}
  margin-bottom: -0.5rem;
`;
exports.SubsTwisterBuyBoxAlertMobileWrapper = styled_components_1.default.div `
  ${SubsTwisterBuyBoxWrapperCommon}
  margin-bottom: 4rem;
`;
exports.SubsTwisterBuyBoxAlertDesktopWrapper = styled_components_1.default.div `
  ${SubsTwisterBuyBoxWrapperCommon}
`;
exports.SubsTwisterBuyBoxDesktopWrapper = styled_components_1.default.div `
  ${SubsTwisterBuyBoxWrapperCommon}
  background-color: #FFFFFF;
  border: 1px solid #d5d9d9;
  border-radius: 8px;
  min-width: 400px;
  max-width: 600px;
  padding: 10px 24px;
`;
